import React, { Component } from "react";
import { connect } from "react-redux";
import {
  changeInPredictAction,
  changeInExeWaitngAction,
  changeWaitngTimeAction,
} from "../../redux/app/actions";
import { changeDsAction as changePlDsAction } from "../../redux/pl/actions";
import { changeDsAction as changeRsltPlDsAction } from "../../redux/rsltPl/actions";

const mapStateToProps = (state) => {
  return {
    ds: state.plReducer.ds,
    //edoya 2021-05-18
    coord: state.modelAreaReducer.coord,
    geoDs: state.geoReducer.dataset,
  };
};

class Main extends Component {
  constructor(props) {
    super(props);
    this.changeField = this.changeField.bind(this);
    this.checkDivNum = this.checkDivNum.bind(this);
    this.doExe = this.doExe.bind(this);
  }

  /*
   * フィールド変更
   * @param {Number} index フィールドの行インデックス
   * @param {String} key フィールドの列インデックス
   * @param {Event} e イベント情報
   * @since hara 2021-02-05
   */
  changeField(index, key, e) {
    const ds = [...this.props.ds];
    ds[index][key] = e.target.value;
    ds[index]["estFlg"] = 0; //未推定に変更
    this.props.dispatch(changePlDsAction(ds));
  }

  /*
   * 分割数チェック
   * @param {Number} index フィールドの行インデックス
   * @param {Event} e イベント情報
   * @since hara 2021-04-19
   */
  checkDivNum(index, key, e) {
    let value = e.target.value;
    if (isNaN(value) || parseFloat(value) < 1) {
      const ds = [...this.props.ds];
      ds[index] = { ...ds[index], [key]: 1 };
      this.props.dispatch(changePlDsAction(ds));
    }
  }

  /*
   * 推定実行
   * @since hara 2021-04-19
   */
  async doExe() {
    //予測位置（平面）が登録されていなければ、予測をスキップ
    if (!this.props.ds.length) return;

    /*
     * 入力値確認
     */
    let divNumFlg = false;
    this.props.ds.forEach((el) => {
      const isInt = (num) => {
        return Number.isInteger(parseFloat(num));
      };

      if (
        !isInt(el.divNumX) ||
        !isInt(el.divNumY) ||
        el.divNumX < 1 ||
        el.divNumY < 1
      )
        divNumFlg = true;
      if (el.divNumX > 100 || el.divNumY > 100) divNumFlg = true;
    });
    if (divNumFlg) {
      alert("分割数は 1以上100以下の整数を設定してください。");
      return;
    }

    /*
     * 予測
     */
    let pls = [];
    //未推定の予測位置（平面）をplsとして抽出
    this.props.ds.forEach((el) => {
      if (el.estFlg === 0) {
        //未推定の場合
        pls = pls.concat(el);
        console.log(`predict ${el["ID"]}.`);
      } else {
        console.log(
          `SKIP ${el["ID"]}. PosPl of ID[${el["ID"]}] already exists.`
        );
      }
    });

    //予測済みの平面しか存在しなければ、予測をスキップ
    if (pls.length === 0) {
      alert("予測は完了しています。");
      return;
    }

    //ローダーの表示・非表示切替
    const waiting = (stat) => {
      this.props.dispatch(changeInPredictAction(stat));
    };
    waiting(true);
    await this.doCheckExe();

    //サーバにデータ送信、予測結果受信（edoya 2021-05-18）
    const ds = this.props.geoDs[0]; //デフォルトの地質データを送る

    let dsData = {
      range: {
        x1: this.props.coord[2],
        x2: this.props.coord[3],
        y1: this.props.coord[1],
        y2: this.props.coord[0],
      },
      ds: pls,
      type: "plane",
      geo: ds.geo,
      exe: "predict",
    };
    console.log("pls:" + JSON.stringify(dsData));

    const origin = window.location.origin;
    const search = window.location.search;
    await fetch(`${origin}/api/0/predict/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(dsData),
    })
      .then((response) => response.json())
      .then((results) => {
        const plDs = [...this.props.ds];
        results.forEach((result) => {
          console.log(`result[${result["ID"]}] received`);
          this.props.dispatch(changeRsltPlDsAction(result));
          plDs[result["ID"] - 1]["estFlg"] = 1; //推定済みに変更
        });
        this.props.dispatch(changePlDsAction(plDs));
        waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      })
      .catch((error) => {
        alert("サーバーエラー");
        waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        console.error("Fetch error:", error);
      });
  }

  /*
   * 実行可否を確認
   * @since ando 2025-07-31
   */
  async doCheckExe() {
    const origin = window.location.origin;
    const search = window.location.search;

    try {
      const res = await fetch(`${origin}/api/0/checkExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "estBoring",
        }),
      });

      const json = await res.json();
      console.log("res", json);

      if (json.result === "OK") {
        return true; // 処理可能
      } else {
        this.props.dispatch(changeWaitngTimeAction(json.waiting_time));
        this.props.dispatch(changeInExeWaitngAction(true)); // GUI表示
        return false; // 待機状態
      }
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      return false; // エラー時も止める
    }
  }
  render() {
    return (
      <div>
        <div className="TWrap" style={{ overflowY: "scroll" }}>
          <table className="autoTable">
            <thead>
              <tr>
                <th className="tsS">平面ID</th>
                <th>Z属性</th>
                <th>Z値</th>
                <th>分割数 (X)</th>
                <th>分割数 (Y)</th>
              </tr>
            </thead>
            <tbody>
              {this.props.ds !== undefined &&
                this.props.ds.map((el, index) => (
                  <tr key={el.ID}>
                    <td>
                      <p>{el.ID}</p>
                    </td>
                    <td>
                      <p>{el.ZAttr === "dep" ? "深度" : "標高"}</p>
                    </td>
                    <td>
                      <p>{el.ZVal}</p>
                    </td>
                    <td>
                      <input
                        className="textT"
                        type="text"
                        value={el.divNumX}
                        onBlur={(e) => this.checkDivNum(index, "divNumX", e)}
                        onChange={(e) => this.changeField(index, "divNumX", e)}
                      />
                    </td>
                    <td>
                      <input
                        className="textT"
                        type="text"
                        value={el.divNumY}
                        onBlur={(e) => this.checkDivNum(index, "divNumY", e)}
                        onChange={(e) => this.changeField(index, "divNumY", e)}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="l-right l-mtM">
          <button className="cBtn" onClick={this.doExe}>
            実行
          </button>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(Main);
